import axios from "axios";

export const subcribeService = (payload: any) => {
  const res = axios.post("/api/emails", { email: payload })
  return res;
};
